import startCase from 'lodash/startCase';

import { IconTooltipItem } from '~/domain';

export function getPlanLabel(orgPlan: string): string {
	return startCase(orgPlan?.toLowerCase());
}

export function getChiftIcon(chiftLabel: string): IconTooltipItem | undefined {
	return chiftLabel ? { label: chiftLabel, icon: 'sitemap' } : undefined;
}
